import { useMemo } from 'react';

export default function useCliManagedIntegrationJson({ deployedRevisions }) {
  return useMemo(
    () =>
      (deployedRevisions ?? []).reduce((integrations, integration) => {
        return integration.cliManaged ? [...integrations, integration.deployedIntegrationJson] : integrations;
      }, []),
    [deployedRevisions]
  );
}
